import { useEffect, useState } from "react";
import { getBrand } from "@shared/components/utils/brandHelper";
import { getBrandLogosWithFallback } from "@shared/components/utils/brandConfig";
import { useTheme } from "theme/components/ThemeProvider";

type BrandLogos = { lightLogo: string; logo: string; nube: string };

/**
 * Resolves current brand logos with dark/light and image fallback to "nube".
 */
export const useSideMenuBrandLogos = () => {
	const { theme } = useTheme();
	const isDark = theme === "theme-dark";
	const brand = getBrand();

	const [logos, setLogos] = useState<BrandLogos>({
		lightLogo: "",
		logo: "",
		nube: "",
	});
	const [logoSrc, setLogoSrc] = useState("");
	const [fallbackApplied, setFallbackApplied] = useState(false);

	useEffect(() => {
		const loadLogos = async () => {
			try {
				const brandLogos = await getBrandLogosWithFallback(brand);
				setLogos(brandLogos);
				setLogoSrc(isDark ? brandLogos.lightLogo : brandLogos.logo);
			} catch (error) {
				console.error("Error loading brand logos:", error);
			}
		};

		void loadLogos();
	}, [brand]);

	useEffect(() => {
		if (logos.lightLogo && logos.logo) {
			setLogoSrc(isDark ? logos.lightLogo : logos.logo);
		}
	}, [isDark, logos.lightLogo, logos.logo]);

	const handleImageError = () => {
		if (!fallbackApplied && logos.nube) {
			setFallbackApplied(true);
			setLogoSrc(logos.nube);
		}
	};

	return { logoSrc, handleImageError };
};
